import { Controller } from '@hotwired/stimulus';

// Number inputs change their value when scrolled over while focused. Blurring on
// wheel keeps the entered amount and lets the page scroll normally.
export default class extends Controller {
  connect() {
    this.blurOnWheel = () => {
      if (this.element === document.activeElement) this.element.blur();
    };

    this.element.addEventListener('wheel', this.blurOnWheel);
  }

  disconnect() {
    this.element.removeEventListener('wheel', this.blurOnWheel);
  }
}
